import { LabelText } from 'shared/ui/label';
import { Container } from './styles';
import { TagsOptions } from 'entities/tags';
import { Textarea } from 'shared/ui/Inputs/textarea';
import { MultiValue } from 'react-select';
import { Option } from 'shared/types';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import {
	selectBookingApplicationMod,
	selectOrderForBooking,
	updateBookingNotes,
	updateBookingTags,
} from 'entities/orders';
import { Controller, ControllerRenderProps, useForm } from 'react-hook-form';
import { ChangeEvent, FocusEvent, useEffect, useMemo, useRef, useState } from 'react';
import { useClientForm } from 'features/booking/BookingClientForm';
import { updateBookingDeposit } from 'entities/orders/model/ordersSlice';
import { OrderBookingData } from 'entities/orders/model/types';
import { localStorageItem } from 'shared/lib/core/lib/utils';
import { useBookingReset } from 'features/booking/BookingClientForm';
import { Input } from 'shared/ui/Inputs/Input';

type FormValues = {
	notes: string;
	prepayment_amount: string;
};

export const BookingForm = () => {

	const { control, setValue, getValues } = useForm<FormValues>({
		defaultValues: {
			notes: '',
			prepayment_amount: ''
		},
	});

	const [tagsOption, setTagsOption] = useState<string[] | []>([]);
	const { activeBookingBtn } = useClientForm();

	const order = useAppSelector(selectOrderForBooking);
	const dataIsLoaded = useRef(false);
	const dispatch = useAppDispatch();
	const applicationMod = useAppSelector(selectBookingApplicationMod);
	const savedData = localStorageItem('booking') as OrderBookingData;

	const selectTag = (values: MultiValue<Option>) => {
		const tags = values.map(val => val.label);
		dispatch(updateBookingTags({ tags }));
		activeBookingBtn();
	};

	const changeNotes = (
		event: ChangeEvent<HTMLTextAreaElement>,
		field: ControllerRenderProps<FormValues, 'notes'>,
	) => {
		const notes = event.target.value;
		field.onChange(event);
		dispatch(updateBookingNotes({ notes }));
		activeBookingBtn();
	};

	const changeDeposit = (
		event: ChangeEvent<HTMLInputElement>,
	) => {
		const deposit = event.target.value;
		const numberDeposit = deposit.replace(/[^\d]/, '').replace(/[ ]/, '').replace(/[^\d]/, '').replace(/[^\d]/, '');

		if (numberDeposit.length > 9) {
			setValue('prepayment_amount', getValues().prepayment_amount.replace(/[^\d]/, ''));
			return;
		}

		const formatedDeposit = numberDeposit;
		setValue('prepayment_amount', formatedDeposit)

		dispatch(updateBookingDeposit({ prepayment_amount: formatedDeposit }));
		activeBookingBtn();
	};

	useEffect(() => {
    console.log('order',order)
    console.log('dataIsLoaded.current',dataIsLoaded.current)
    
		if (order && !dataIsLoaded.current) {
			const notes = order.notes;
			const prepayment_amount = order.prepayment_amount;
			const tags = order.tags;

			if (notes) {
				setValue('notes', notes);
				dispatch(updateBookingNotes({ notes }));
			}

			if (prepayment_amount) {
				setValue('prepayment_amount', prepayment_amount ? (+prepayment_amount).toString() : '');
				dispatch(updateBookingDeposit({ prepayment_amount: prepayment_amount ? (+prepayment_amount).toString() : '' }));
			}

			if (tags.length) {
				setTagsOption(tags);
			}
		}

		if (!order && savedData) {
			setTagsOption(savedData.tags);
		}
		dataIsLoaded.current = true;
		// eslint-disable-next-line
	}, [order, setValue, dispatch]);

	const notesLabelText = useMemo(() => {
		if (applicationMod) {
			return 'заявке';
		} else {
			return 'бронированию';
		}
	}, [applicationMod]);


	useEffect(() => {
		if (savedData) {
			setValue('notes', savedData.notes);
			setValue('prepayment_amount', savedData.prepayment_amount)
		}
		// eslint-disable-next-line
	}, []);

	useBookingReset(() => {
		setValue('notes', '');
		setValue('prepayment_amount', '');
		setTagsOption([]);
	})

  const mhzOnFocus = (e: FocusEvent<any>, selector: string = '') => {
    let element = e.target;
    if (selector.trim()) {
      element = element.closest(selector);
    }

    const minus = (element.parentElement ? element.parentElement.offsetHeight * 2 : 0) + 20;
    const top = element.offsetTop - minus;

    if (element !== null&&Number.isInteger(element.offsetTop)) {
      setTimeout(() => {
        document.getElementById('booking-scrollable')?.scrollTo({
          top,
          behavior: "smooth"
        });
      }, 0);
    }
  }

	return (
		<>
			<Container>
				<LabelText>Комментарий к {notesLabelText}</LabelText>
				<Controller
					name="notes"
					control={control}
					render={({ field }) => (
						<Textarea
							name={field.name}
							value={field.value}
							onChange={event => changeNotes(event, field)}
              onFocus={mhzOnFocus}
						/>
					)}
				/>
			</Container>

			<Container>
				<LabelText>Теги</LabelText>
				<TagsOptions
					isForOrder={true}
					onSelect={selectTag}
					tagsOptions={tagsOption}
          onFocus={mhzOnFocus}
				/>
			</Container>
			<Container style={{ width: '50%' }}>
				<LabelText>Депозит</LabelText>
				<Controller
					name="prepayment_amount"
					control={control}
					render={({ field }) => (
						<>
							<Input
								name={field.name}
								value={field.value ? Number(field.value).toLocaleString() : ''}
								onChange={event => changeDeposit(event)}
                onFocus={mhzOnFocus}
							/>
						</>
					)}
				/>
			</Container>
		</>
	);
};
